/**
 * 品项业务规则：储值卡按主档 qt1=「储值」固定判定。
 */

export const STORED_VALUE_QT1 = '储值'

export function isStoredValueCard(itemOrQt1) {
  const qt1 = typeof itemOrQt1 === 'string' ? itemOrQt1 : (itemOrQt1 && (itemOrQt1.qt1 || itemOrQt1.Qt1))
  if (!qt1) return false
  return String(qt1).trim() === STORED_VALUE_QT1
}

export function resolveDeductTypeByQt1(qt1) {
  return isStoredValueCard(qt1) ? '储值卡' : '品项'
}

export default {
  STORED_VALUE_QT1,
  isStoredValueCard,
  resolveDeductTypeByQt1
}
